import { toast } from "@/lib/instrumented-toast";
import { useApiInstance } from "@/providers/api-provider";
import { AxiosError } from "axios";

export function messageFromAxiosOrError(error: unknown): string {
  if (error instanceof AxiosError && error.response?.data) {
    const data = error.response.data as { detail?: unknown };
    const detail = data.detail;
    if (typeof detail === "string") {
      return detail;
    }
    if (Array.isArray(detail)) {
      const msgs = detail
        .map((item) =>
          typeof item === "object" && item !== null && "msg" in item
            ? String((item as { msg: string }).msg)
            : JSON.stringify(item),
        )
        .filter(Boolean);
      if (msgs.length > 0) {
        return msgs.join("; ");
      }
    }
  }
  return error instanceof Error ? error.message : String(error);
}

export async function copyInviteLink(user: { id: string; organization_id?: string; email: string }) {
  if (!user.organization_id) {
    toast.error(`Cannot create an invite link: ${user.email} has no organization`);
    return;
  }
  try {
    const { data } = await useApiInstance.post<{ invite_link: string }>(
      `/api/v1/organizations/${user.organization_id}/users/${user.id}/invite-link`,
      undefined,
      { params: { login_name: user.email } },
    );
    try {
      await navigator.clipboard.writeText(data.invite_link);
      toast.success(`Invite link for ${user.email} copied to clipboard`);
    } catch {
      // Clipboard access can be blocked outside a direct user gesture (e.g. Safari)
      window.prompt(`Copy the invite link for ${user.email}:`, data.invite_link);
    }
  } catch (error: unknown) {
    toast.error(`Failed to create invite link: ${messageFromAxiosOrError(error)}`);
  }
}
